/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 2xx-2Vrj4B1-

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomeBenefitsSectionBenefits.module.css"; // plasmic-import: 2xx-2Vrj4B1-/css

createPlasmicElementProxy;

export type PlasmicHomeBenefitsSectionBenefits__VariantMembers = {
  pov: "director" | "officer" | "administrator";
};
export type PlasmicHomeBenefitsSectionBenefits__VariantsArgs = {
  pov?: SingleChoiceArg<"director" | "officer" | "administrator">;
};
type VariantPropType = keyof PlasmicHomeBenefitsSectionBenefits__VariantsArgs;
export const PlasmicHomeBenefitsSectionBenefits__VariantProps =
  new Array<VariantPropType>("pov");

export type PlasmicHomeBenefitsSectionBenefits__ArgsType = {};
type ArgPropType = keyof PlasmicHomeBenefitsSectionBenefits__ArgsType;
export const PlasmicHomeBenefitsSectionBenefits__ArgProps =
  new Array<ArgPropType>();

export type PlasmicHomeBenefitsSectionBenefits__OverridesType = {
  items?: Flex__<"div">;
  desktopWrapper?: Flex__<"div">;
  row5?: Flex__<"div">;
  textWithIcon?: Flex__<"div">;
  featureIcon?: Flex__<"div">;
  heading?: Flex__<"h3">;
  text11?: Flex__<"p">;
  textWithIcon2?: Flex__<"div">;
  featureIcon2?: Flex__<"div">;
  heading2?: Flex__<"h3">;
  text22?: Flex__<"p">;
  textWithIcon3?: Flex__<"div">;
  featureIcon3?: Flex__<"div">;
  heading3?: Flex__<"h3">;
  text5?: Flex__<"p">;
  row6?: Flex__<"div">;
  textWithIcon4?: Flex__<"div">;
  featureIcon4?: Flex__<"div">;
  heading4?: Flex__<"h3">;
  text6?: Flex__<"p">;
  textWithIcon5?: Flex__<"div">;
  featureIcon5?: Flex__<"div">;
  heading5?: Flex__<"h3">;
  text7?: Flex__<"p">;
  textWithIcon6?: Flex__<"div">;
  featureIcon6?: Flex__<"div">;
  heading6?: Flex__<"h3">;
  text8?: Flex__<"p">;
  tabletWrapper?: Flex__<"div">;
  row7?: Flex__<"div">;
  textWithIcon7?: Flex__<"div">;
  featureIcon7?: Flex__<"div">;
  heading7?: Flex__<"h3">;
  text12?: Flex__<"p">;
  textWithIcon8?: Flex__<"div">;
  featureIcon8?: Flex__<"div">;
  heading8?: Flex__<"h3">;
  text9?: Flex__<"p">;
  row8?: Flex__<"div">;
  textWithIcon9?: Flex__<"div">;
  featureIcon9?: Flex__<"div">;
  heading9?: Flex__<"h3">;
  text10?: Flex__<"p">;
  textWithIcon10?: Flex__<"div">;
  featureIcon10?: Flex__<"div">;
  heading10?: Flex__<"h3">;
  text13?: Flex__<"p">;
  row9?: Flex__<"div">;
  textWithIcon11?: Flex__<"div">;
  featureIcon11?: Flex__<"div">;
  heading11?: Flex__<"h3">;
  text14?: Flex__<"p">;
  textWithIcon12?: Flex__<"div">;
  featureIcon12?: Flex__<"div">;
  heading12?: Flex__<"h3">;
  text15?: Flex__<"p">;
  mobileWrapper?: Flex__<"div">;
  textWithIcon13?: Flex__<"div">;
  featureIcon13?: Flex__<"div">;
  heading13?: Flex__<"h3">;
  text16?: Flex__<"p">;
  textWithIcon14?: Flex__<"div">;
  featureIcon14?: Flex__<"div">;
  heading14?: Flex__<"h3">;
  freeBox?: Flex__<"div">;
  text17?: Flex__<"p">;
  textWithIcon15?: Flex__<"div">;
  featureIcon15?: Flex__<"div">;
  heading15?: Flex__<"h3">;
  text18?: Flex__<"p">;
  textWithIcon16?: Flex__<"div">;
  featureIcon16?: Flex__<"div">;
  heading16?: Flex__<"h3">;
  text19?: Flex__<"p">;
  textWithIcon17?: Flex__<"div">;
  featureIcon17?: Flex__<"div">;
  heading17?: Flex__<"h3">;
  text20?: Flex__<"p">;
  textWithIcon18?: Flex__<"div">;
  featureIcon18?: Flex__<"div">;
  heading18?: Flex__<"h3">;
  text21?: Flex__<"p">;
};

export interface DefaultHomeBenefitsSectionBenefitsProps {
  pov?: SingleChoiceArg<"director" | "officer" | "administrator">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeBenefitsSectionBenefits__RenderFunc(props: {
  variants: PlasmicHomeBenefitsSectionBenefits__VariantsArgs;
  args: PlasmicHomeBenefitsSectionBenefits__ArgsType;
  overrides: PlasmicHomeBenefitsSectionBenefits__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "pov",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.pov
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"items"}
      data-plasmic-override={overrides.items}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.items,
        {
          [sty.itemspov_administrator]: hasVariant(
            $state,
            "pov",
            "administrator"
          ),
          [sty.itemspov_director]: hasVariant($state, "pov", "director"),
          [sty.itemspov_officer]: hasVariant($state, "pov", "officer")
        }
      )}
    >
      {(
        hasVariant(globalVariants, "mobile", "tabletPortrait") ? false : true
      ) ? (
        <div
          data-plasmic-name={"desktopWrapper"}
          data-plasmic-override={overrides.desktopWrapper}
          className={classNames("all", sty.desktopWrapper)}
        >
          <div
            data-plasmic-name={"row5"}
            data-plasmic-override={overrides.row5}
            className={classNames("all", sty.row5, {
              [sty.row5pov_officer]: hasVariant($state, "pov", "officer")
            })}
          >
            <div
              data-plasmic-name={"textWithIcon"}
              data-plasmic-override={overrides.textWithIcon}
              className={classNames("all", sty.textWithIcon, {
                [sty.textWithIconpov_officer]: hasVariant(
                  $state,
                  "pov",
                  "officer"
                )
              })}
            >
              <div
                data-plasmic-name={"featureIcon"}
                data-plasmic-override={overrides.featureIcon}
                className={classNames("all", sty.featureIcon)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__loTpS, {
                    [sty.imgpov_administrator__loTpS2Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__loTpScOt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/ac1f76fb50fbf8c90d7aa8684c455371.svg",
                          fullWidth: 150,
                          fullHeight: 150,
                          aspectRatio: 1
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/eaddc0e11d5b62bbe50f3f5891aba403.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                        : {
                            src: "https://site-assets.plasmic.app/7b9b8ce2dc163f1260d75b8c5872c101.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading"}
                data-plasmic-override={overrides.heading}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading,
                  {
                    [sty.headingpov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.headingpov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Reduce Risk with Compliance Alerts & Reminders"
                  : hasVariant($state, "pov", "officer")
                    ? "Maximize Savings through Strategic Staff Reallocation"
                    : "Use Future-Proof \nMilestone & EPA Integration"}
              </h3>
              <p
                data-plasmic-name={"text11"}
                data-plasmic-override={overrides.text11}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text11,
                  {
                    [sty.text11pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text11pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Benefit from automated notifications for critical thresholds, customizable alerts aligned with your institution's needs, and timely reminders for key compliance activities, ensuring proactive adherence to standards."
                  : hasVariant($state, "pov", "officer")
                    ? "Optimize resource allocation with FTE CAP Analysis, enhancing productivity and strategic planning. Gain insights into capacity utilization, balancing workloads effectively to maximize savings."
                    : "With integrated milestones & EPAs, track trainee progress comprehensively. Tailored strategies and clear learning objectives ensure consistency in evaluations, aligning with evolving industry standards."}
              </p>
            </div>
            <div
              data-plasmic-name={"textWithIcon2"}
              data-plasmic-override={overrides.textWithIcon2}
              className={classNames("all", sty.textWithIcon2)}
            >
              <div
                data-plasmic-name={"featureIcon2"}
                data-plasmic-override={overrides.featureIcon2}
                className={classNames("all", sty.featureIcon2)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__mtntD, {
                    [sty.imgpov_administrator__mtntD2Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__mtntDcOt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/c9d5343d55296d4f23164870386db9ad.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/0b262b60f4d3536617e5464967729485.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/fe7498e2fb892eddf0cceef2ce1dc90c.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading2"}
                data-plasmic-override={overrides.heading2}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading2,
                  {
                    [sty.heading2pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading2pov_director]: hasVariant(
                      $state,
                      "pov",
                      "director"
                    ),
                    [sty.heading2pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Identify Gaps in \nTrainee Education"
                  : hasVariant($state, "pov", "officer")
                    ? "Support Your Decisions with Historical Data and Trends"
                    : "Easily Onboard Trainees and Manage All Document Requirements"}
              </h3>
              <p
                data-plasmic-name={"text22"}
                data-plasmic-override={overrides.text22}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text22,
                  {
                    [sty.text22pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text22pov_director]: hasVariant(
                      $state,
                      "pov",
                      "director"
                    ),
                    [sty.text22pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Optimize trainee education using MyEvaluations' integrated milestones, EPAs, and MyInsights' AI-generated feedback. Tailor evaluations to meet institution-specific goals, empowering focused growth and readiness for exceptional patient care."
                  : hasVariant($state, "pov", "officer")
                    ? "Empower decision-making with MyEvaluations' sophisticated analytics. Utilize insights from Annual Program Evaluations and other reports to identify trends, improve programs, and set new benchmarks in medical education excellence."
                    : "Simplify onboarding and credentialing with automated tools. Ensure compliance, reduce errors, and efficiently validate credentials for resident qualifications. Manage demographic data seamlessly while maintaining secure and organized information access."}
              </p>
            </div>
            <div
              data-plasmic-name={"textWithIcon3"}
              data-plasmic-override={overrides.textWithIcon3}
              className={classNames("all", sty.textWithIcon3)}
            >
              <div
                data-plasmic-name={"featureIcon3"}
                data-plasmic-override={overrides.featureIcon3}
                className={classNames("all", sty.featureIcon3)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__r9XHr, {
                    [sty.imgpov_administrator__r9XHr2Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__r9XHrcOt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/d3c4632dc560f1e75d09c01b943bb415.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/a2972b2453055fda2ff4271069674fd7.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/3c310446c6021e3ac137c9f7dec8c08f.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading3"}
                data-plasmic-override={overrides.heading3}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading3,
                  {
                    [sty.heading3pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading3pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Centralize All Your Educational Resources"
                  : hasVariant($state, "pov", "officer")
                    ? "Identify Gaps in \nTrainee Education"
                    : "Enhance Academic Performance through Continuous Assessments"}
              </h3>
              <p
                data-plasmic-name={"text5"}
                data-plasmic-override={overrides.text5}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text5,
                  {
                    [sty.text5pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text5pov_officer]: hasVariant($state, "pov", "officer")
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Access high-quality learning materials on demand, foster dynamic curriculum development, and engage trainees with tailored assignments and interactive quizzes, ensuring an enriched learning experience for all."
                  : hasVariant($state, "pov", "officer")
                    ? "Optimize trainee education using MyEvaluations' integrated milestones, EPAs, and MyInsights' AI-generated feedback. Tailor evaluations to meet institution-specific goals, empowering focused growth and readiness for exceptional patient care."
                    : "Enrich learning with tailored assignments and interactive quizzes, providing oversight on objectives, and monitoring knowledge retention. Gain insights into trainee performance with assessment tools for continuous improvement."}
              </p>
            </div>
          </div>
          <div
            data-plasmic-name={"row6"}
            data-plasmic-override={overrides.row6}
            className={classNames("all", sty.row6, {
              [sty.row6pov_officer]: hasVariant($state, "pov", "officer")
            })}
          >
            <div
              data-plasmic-name={"textWithIcon4"}
              data-plasmic-override={overrides.textWithIcon4}
              className={classNames("all", sty.textWithIcon4)}
            >
              <div
                data-plasmic-name={"featureIcon4"}
                data-plasmic-override={overrides.featureIcon4}
                className={classNames("all", sty.featureIcon4)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__pkUXb, {
                    [sty.imgpov_administrator__pkUXb2Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__pkUXbcOt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/4a7d04d490ec43b544075c6054040e0c.svg",
                          fullWidth: 150,
                          fullHeight: 150,
                          aspectRatio: 1
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/eb32ad08bc41319b6a8fca3d9400b78f.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                        : {
                            src: "https://site-assets.plasmic.app/ff4c5cc66db326a029e99abef3aa57d7.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading4"}
                data-plasmic-override={overrides.heading4}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading4,
                  {
                    [sty.heading4pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading4pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Effortlessly Generate Optimized Schedules"
                  : hasVariant($state, "pov", "officer")
                    ? "Develop Exceptional Trainees with Comprehensive Educational Tracking"
                    : "Deliver Quicker and Comprehensive Trainee Narrative Feedback"}
              </h3>
              <p
                data-plasmic-name={"text6"}
                data-plasmic-override={overrides.text6}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text6,
                  {
                    [sty.text6pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text6pov_officer]: hasVariant($state, "pov", "officer")
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "From rotations to clinics, MySchedule streamlines scheduling complexities. Benefit from mobile access, automated scheduling, and unified cross-departmental coordination, all ensuring optimized training workflows."
                  : hasVariant($state, "pov", "officer")
                    ? "Drive exceptional trainee development through robust quizzes and tailored learning assignments. With comprehensive educational tracking and real-time progress monitoring, MyEvaluations ensures alignment with goals for enriched learning experiences."
                    : "Experience the power of MyInsights, an AI-driven tool that saves Clinical Competency Committee time. It translates comments and performance data into human-readable, actionable summaries, offering valuable feedback to all trainees."}
              </p>
            </div>
            <div
              data-plasmic-name={"textWithIcon5"}
              data-plasmic-override={overrides.textWithIcon5}
              className={classNames("all", sty.textWithIcon5)}
            >
              <div
                data-plasmic-name={"featureIcon5"}
                data-plasmic-override={overrides.featureIcon5}
                className={classNames("all", sty.featureIcon5)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__nYGjI, {
                    [sty.imgpov_administrator__nYGjI2Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__nYGjIcOt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/acd1b2c6599f8032a133a63d5f393bcc.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/7b7198bc93fb580da1f9e623ffdb7533.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/1812cd43fefaebf83e3a0ec1eb4d0fa9.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading5"}
                data-plasmic-override={overrides.heading5}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading5,
                  {
                    [sty.heading5pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading5pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Deliver Quicker and Comprehensive Trainee Narrative Feedback"
                  : hasVariant($state, "pov", "officer")
                    ? "Reduce Burnout and Easily Track Clinical Hours"
                    : "Simplify CME Organization and Minimize Admin Burden"}
              </h3>
              <p
                data-plasmic-name={"text7"}
                data-plasmic-override={overrides.text7}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text7,
                  {
                    [sty.text7pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text7pov_officer]: hasVariant($state, "pov", "officer")
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Experience the power of MyInsights, an AI-driven tool that saves Clinical Competency Committee time. It translates comments and performance data into human-readable, actionable summaries, offering valuable feedback to all trainees."
                  : hasVariant($state, "pov", "officer")
                    ? "Simplify clinical hour tracking using MyQuickPass' geofence technology, allowing trainees to focus on tasks, promoting their well-being. Automated records ensure compliance, with real-time alerts and streamlined reports benefit administrators."
                    : "Efficiently manage your CME program with streamlined event scheduling, durable event libraries, and precise financial oversight. With MyCME you ensure optimal resource allocation and secure payment processing for fee collection."}
              </p>
            </div>
            <div
              data-plasmic-name={"textWithIcon6"}
              data-plasmic-override={overrides.textWithIcon6}
              className={classNames("all", sty.textWithIcon6)}
            >
              <div
                data-plasmic-name={"featureIcon6"}
                data-plasmic-override={overrides.featureIcon6}
                className={classNames("all", sty.featureIcon6)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__h2Sx7, {
                    [sty.imgpov_administrator__h2Sx72Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__h2Sx7COt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/7d556af7fe90b36896fe9ba459b2f6dc.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/e691a5160e5fa6714b289da2a425b480.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/602539a406e5eb93e4e725bc14216ca0.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading6"}
                data-plasmic-override={overrides.heading6}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading6,
                  {
                    [sty.heading6pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading6pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Easily Onboard Trainees and Manage All Document Requirements"
                  : hasVariant($state, "pov", "officer")
                    ? "Stay Ahead with Proactive Fiscal Management"
                    : "Support Your Decisions with Historical Data and Trends"}
              </h3>
              <p
                data-plasmic-name={"text8"}
                data-plasmic-override={overrides.text8}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text8,
                  {
                    [sty.text8pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text8pov_officer]: hasVariant($state, "pov", "officer")
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Simplify onboarding and credentialing with automated tools. Ensure compliance, reduce errors, and efficiently validate credentials for resident qualifications. Manage demographic data seamlessly while maintaining secure and organized information access."
                  : hasVariant($state, "pov", "officer")
                    ? "Streamline financial processes, reduce administrative overhead, and ensure transparent dealings with stakeholders. Review submissions proactively for a forward-thinking approach to financial management."
                    : "Empower decision-making with MyEvaluations' sophisticated analytics. Utilize insights from Annual Program Evaluations and other reports to identify trends, improve programs, and set new benchmarks in medical education excellence."}
              </p>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"tabletWrapper"}
          data-plasmic-override={overrides.tabletWrapper}
          className={classNames("all", sty.tabletWrapper)}
        >
          <div
            data-plasmic-name={"row7"}
            data-plasmic-override={overrides.row7}
            className={classNames("all", sty.row7, {
              [sty.row7pov_officer]: hasVariant($state, "pov", "officer")
            })}
          >
            <div
              data-plasmic-name={"textWithIcon7"}
              data-plasmic-override={overrides.textWithIcon7}
              className={classNames("all", sty.textWithIcon7, {
                [sty.textWithIcon7pov_officer]: hasVariant(
                  $state,
                  "pov",
                  "officer"
                )
              })}
            >
              <div
                data-plasmic-name={"featureIcon7"}
                data-plasmic-override={overrides.featureIcon7}
                className={classNames("all", sty.featureIcon7)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__jFi64, {
                    [sty.imgpov_administrator__jFi642Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__jFi64COt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/ac1f76fb50fbf8c90d7aa8684c455371.svg",
                          fullWidth: 150,
                          fullHeight: 150,
                          aspectRatio: 1
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/eaddc0e11d5b62bbe50f3f5891aba403.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                        : {
                            src: "https://site-assets.plasmic.app/7b9b8ce2dc163f1260d75b8c5872c101.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading7"}
                data-plasmic-override={overrides.heading7}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading7,
                  {
                    [sty.heading7pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading7pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Reduce Risk with Compliance Alerts & Reminders"
                  : hasVariant($state, "pov", "officer")
                    ? "Maximize Savings through Strategic Staff Reallocation"
                    : "Use Future-Proof \nMilestone & EPA Integration"}
              </h3>
              <p
                data-plasmic-name={"text12"}
                data-plasmic-override={overrides.text12}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text12,
                  {
                    [sty.text12pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text12pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Benefit from automated notifications for critical thresholds, customizable alerts aligned with your institution's needs, and timely reminders for key compliance activities, ensuring proactive adherence to standards."
                  : hasVariant($state, "pov", "officer")
                    ? "Optimize resource allocation with FTE CAP Analysis, enhancing productivity and strategic planning. Gain insights into capacity utilization, balancing workloads effectively to maximize savings."
                    : "With integrated milestones & EPAs, track trainee progress comprehensively. Tailored strategies and clear learning objectives ensure consistency in evaluations, aligning with evolving industry standards."}
              </p>
            </div>
            <div
              data-plasmic-name={"textWithIcon8"}
              data-plasmic-override={overrides.textWithIcon8}
              className={classNames("all", sty.textWithIcon8)}
            >
              <div
                data-plasmic-name={"featureIcon8"}
                data-plasmic-override={overrides.featureIcon8}
                className={classNames("all", sty.featureIcon8)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__uui20, {
                    [sty.imgpov_administrator__uui202Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__uui20COt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/c9d5343d55296d4f23164870386db9ad.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/0b262b60f4d3536617e5464967729485.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/fe7498e2fb892eddf0cceef2ce1dc90c.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading8"}
                data-plasmic-override={overrides.heading8}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading8,
                  {
                    [sty.heading8pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading8pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Identify Gaps in \nTrainee Education"
                  : hasVariant($state, "pov", "officer")
                    ? "Support Your Decisions with Historical Data and Trends"
                    : "Easily Onboard Trainees and Manage All Document Requirements"}
              </h3>
              <p
                data-plasmic-name={"text9"}
                data-plasmic-override={overrides.text9}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text9,
                  {
                    [sty.text9pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text9pov_director]: hasVariant(
                      $state,
                      "pov",
                      "director"
                    ),
                    [sty.text9pov_officer]: hasVariant($state, "pov", "officer")
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Optimize trainee education using MyEvaluations' integrated milestones, EPAs, and MyInsights' AI-generated feedback. Tailor evaluations to meet institution-specific goals, empowering focused growth and readiness for exceptional patient care."
                  : hasVariant($state, "pov", "officer")
                    ? "Empower decision-making with MyEvaluations' sophisticated analytics. Utilize insights from Annual Program Evaluations and other reports to identify trends, improve programs, and set new benchmarks in medical education excellence."
                    : "Simplify onboarding and credentialing with automated tools. Ensure compliance, reduce errors, and efficiently validate credentials for resident qualifications. Manage demographic data seamlessly while maintaining secure and organized information access."}
              </p>
            </div>
          </div>
          <div
            data-plasmic-name={"row8"}
            data-plasmic-override={overrides.row8}
            className={classNames("all", sty.row8, {
              [sty.row8pov_officer]: hasVariant($state, "pov", "officer")
            })}
          >
            <div
              data-plasmic-name={"textWithIcon9"}
              data-plasmic-override={overrides.textWithIcon9}
              className={classNames("all", sty.textWithIcon9)}
            >
              <div
                data-plasmic-name={"featureIcon9"}
                data-plasmic-override={overrides.featureIcon9}
                className={classNames("all", sty.featureIcon9)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__rAvi5, {
                    [sty.imgpov_administrator__rAvi52Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__rAvi5COt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/d3c4632dc560f1e75d09c01b943bb415.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/a2972b2453055fda2ff4271069674fd7.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/3c310446c6021e3ac137c9f7dec8c08f.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading9"}
                data-plasmic-override={overrides.heading9}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading9,
                  {
                    [sty.heading9pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading9pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Centralize All Your Educational Resources"
                  : hasVariant($state, "pov", "officer")
                    ? "Identify Gaps in \nTrainee Education"
                    : "Enhance Academic Performance through Continuous Assessments"}
              </h3>
              <p
                data-plasmic-name={"text10"}
                data-plasmic-override={overrides.text10}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text10,
                  {
                    [sty.text10pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text10pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Access high-quality learning materials on demand, foster dynamic curriculum development, and engage trainees with tailored assignments and interactive quizzes, ensuring an enriched learning experience for all."
                  : hasVariant($state, "pov", "officer")
                    ? "Optimize trainee education using MyEvaluations' integrated milestones, EPAs, and MyInsights' AI-generated feedback. Tailor evaluations to meet institution-specific goals, empowering focused growth and readiness for exceptional patient care."
                    : "Enrich learning with tailored assignments and interactive quizzes, providing oversight on objectives, and monitoring knowledge retention. Gain insights into trainee performance with assessment tools for continuous improvement."}
              </p>
            </div>
            <div
              data-plasmic-name={"textWithIcon10"}
              data-plasmic-override={overrides.textWithIcon10}
              className={classNames("all", sty.textWithIcon10)}
            >
              <div
                data-plasmic-name={"featureIcon10"}
                data-plasmic-override={overrides.featureIcon10}
                className={classNames("all", sty.featureIcon10)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img___1DAoD, {
                    [sty.imgpov_administrator___1DAoD2Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer___1DAoDcOt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/4a7d04d490ec43b544075c6054040e0c.svg",
                          fullWidth: 150,
                          fullHeight: 150,
                          aspectRatio: 1
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/eb32ad08bc41319b6a8fca3d9400b78f.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                        : {
                            src: "https://site-assets.plasmic.app/ff4c5cc66db326a029e99abef3aa57d7.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading10"}
                data-plasmic-override={overrides.heading10}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading10,
                  {
                    [sty.heading10pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading10pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Effortlessly Generate Optimized Schedules"
                  : hasVariant($state, "pov", "officer")
                    ? "Develop Exceptional Trainees with Comprehensive Educational Tracking"
                    : "Deliver Quicker and Comprehensive Trainee Narrative Feedback"}
              </h3>
              <p
                data-plasmic-name={"text13"}
                data-plasmic-override={overrides.text13}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text13,
                  {
                    [sty.text13pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text13pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "From rotations to clinics, MySchedule streamlines scheduling complexities. Benefit from mobile access, automated scheduling, and unified cross-departmental coordination, all ensuring optimized training workflows."
                  : hasVariant($state, "pov", "officer")
                    ? "Drive exceptional trainee development through robust quizzes and tailored learning assignments. With comprehensive educational tracking and real-time progress monitoring, MyEvaluations ensures alignment with goals for enriched learning experiences."
                    : "Experience the power of MyInsights, an AI-driven tool that saves Clinical Competency Committee time. It translates comments and performance data into human-readable, actionable summaries, offering valuable feedback to all trainees."}
              </p>
            </div>
          </div>
          <div
            data-plasmic-name={"row9"}
            data-plasmic-override={overrides.row9}
            className={classNames("all", sty.row9, {
              [sty.row9pov_officer]: hasVariant($state, "pov", "officer")
            })}
          >
            <div
              data-plasmic-name={"textWithIcon11"}
              data-plasmic-override={overrides.textWithIcon11}
              className={classNames("all", sty.textWithIcon11)}
            >
              <div
                data-plasmic-name={"featureIcon11"}
                data-plasmic-override={overrides.featureIcon11}
                className={classNames("all", sty.featureIcon11)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__fMrt1, {
                    [sty.imgpov_administrator__fMrt12Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__fMrt1COt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/acd1b2c6599f8032a133a63d5f393bcc.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/7b7198bc93fb580da1f9e623ffdb7533.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/1812cd43fefaebf83e3a0ec1eb4d0fa9.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading11"}
                data-plasmic-override={overrides.heading11}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading11,
                  {
                    [sty.heading11pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading11pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Deliver Quicker and Comprehensive Trainee Narrative Feedback"
                  : hasVariant($state, "pov", "officer")
                    ? "Reduce Burnout and Easily Track Clinical Hours"
                    : "Simplify CME Organization and Minimize Admin Burden"}
              </h3>
              <p
                data-plasmic-name={"text14"}
                data-plasmic-override={overrides.text14}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text14,
                  {
                    [sty.text14pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text14pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Experience the power of MyInsights, an AI-driven tool that saves Clinical Competency Committee time. It translates comments and performance data into human-readable, actionable summaries, offering valuable feedback to all trainees."
                  : hasVariant($state, "pov", "officer")
                    ? "Simplify clinical hour tracking using MyQuickPass' geofence technology, allowing trainees to focus on tasks, promoting their well-being. Automated records ensure compliance, with real-time alerts and streamlined reports benefit administrators."
                    : "Efficiently manage your CME program with streamlined event scheduling, durable event libraries, and precise financial oversight. With MyCME you ensure optimal resource allocation and secure payment processing for fee collection."}
              </p>
            </div>
            <div
              data-plasmic-name={"textWithIcon12"}
              data-plasmic-override={overrides.textWithIcon12}
              className={classNames("all", sty.textWithIcon12)}
            >
              <div
                data-plasmic-name={"featureIcon12"}
                data-plasmic-override={overrides.featureIcon12}
                className={classNames("all", sty.featureIcon12)}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__tQnl6, {
                    [sty.imgpov_administrator__tQnl62Yr]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.imgpov_officer__tQnl6COt9]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  })}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant($state, "pov", "administrator")
                      ? {
                          src: "https://site-assets.plasmic.app/7d556af7fe90b36896fe9ba459b2f6dc.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : hasVariant($state, "pov", "officer")
                        ? {
                            src: "https://site-assets.plasmic.app/e691a5160e5fa6714b289da2a425b480.svg",
                            fullWidth: 155,
                            fullHeight: 150,
                            aspectRatio: 1.03125
                          }
                        : {
                            src: "https://site-assets.plasmic.app/602539a406e5eb93e4e725bc14216ca0.svg",
                            fullWidth: 32,
                            fullHeight: 32,
                            aspectRatio: 1
                          }
                  }
                />
              </div>
              <h3
                data-plasmic-name={"heading12"}
                data-plasmic-override={overrides.heading12}
                className={classNames(
                  "all",
                  "h3",
                  "h3__bvRZj",
                  "__wab_text",
                  sty.heading12,
                  {
                    [sty.heading12pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.heading12pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Easily Onboard Trainees and Manage All Document Requirements"
                  : hasVariant($state, "pov", "officer")
                    ? "Stay Ahead with Proactive Fiscal Management"
                    : "Support Your Decisions with Historical Data and Trends"}
              </h3>
              <p
                data-plasmic-name={"text15"}
                data-plasmic-override={overrides.text15}
                className={classNames(
                  "all",
                  "p",
                  "p__bvRZj",
                  "__wab_text",
                  sty.text15,
                  {
                    [sty.text15pov_administrator]: hasVariant(
                      $state,
                      "pov",
                      "administrator"
                    ),
                    [sty.text15pov_officer]: hasVariant(
                      $state,
                      "pov",
                      "officer"
                    )
                  }
                )}
              >
                {hasVariant($state, "pov", "administrator")
                  ? "Simplify onboarding and credentialing with automated tools. Ensure compliance, reduce errors, and efficiently validate credentials for resident qualifications. Manage demographic data seamlessly while maintaining secure and organized information access."
                  : hasVariant($state, "pov", "officer")
                    ? "Streamline financial processes, reduce administrative overhead, and ensure transparent dealings with stakeholders. Review submissions proactively for a forward-thinking approach to financial management."
                    : "Empower decision-making with MyEvaluations' sophisticated analytics. Utilize insights from Annual Program Evaluations and other reports to identify trends, improve programs, and set new benchmarks in medical education excellence."}
              </p>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? true
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? false
            : false
      ) ? (
        <div
          data-plasmic-name={"mobileWrapper"}
          data-plasmic-override={overrides.mobileWrapper}
          className={classNames("all", sty.mobileWrapper)}
        >
          <div
            data-plasmic-name={"textWithIcon13"}
            data-plasmic-override={overrides.textWithIcon13}
            className={classNames("all", sty.textWithIcon13, {
              [sty.textWithIcon13pov_officer]: hasVariant(
                $state,
                "pov",
                "officer"
              )
            })}
          >
            <div
              data-plasmic-name={"featureIcon13"}
              data-plasmic-override={overrides.featureIcon13}
              className={classNames("all", sty.featureIcon13)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__oSkog, {
                  [sty.imgpov_administrator__oSkog2Yr]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.imgpov_officer__oSkogcOt9]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                })}
                displayHeight={"32px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"32px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant($state, "pov", "administrator")
                    ? {
                        src: "https://site-assets.plasmic.app/ac1f76fb50fbf8c90d7aa8684c455371.svg",
                        fullWidth: 150,
                        fullHeight: 150,
                        aspectRatio: 1
                      }
                    : hasVariant($state, "pov", "officer")
                      ? {
                          src: "https://site-assets.plasmic.app/eaddc0e11d5b62bbe50f3f5891aba403.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                      : {
                          src: "https://site-assets.plasmic.app/7b9b8ce2dc163f1260d75b8c5872c101.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                }
              />
            </div>
            <h3
              data-plasmic-name={"heading13"}
              data-plasmic-override={overrides.heading13}
              className={classNames(
                "all",
                "h3",
                "h3__bvRZj",
                "__wab_text",
                sty.heading13,
                {
                  [sty.heading13pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.heading13pov_officer]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Reduce Risk with Compliance Alerts & Reminders"
                : hasVariant($state, "pov", "officer")
                  ? "Maximize Savings through Strategic Staff Reallocation"
                  : "Use Future-Proof \nMilestone & EPA Integration"}
            </h3>
            <p
              data-plasmic-name={"text16"}
              data-plasmic-override={overrides.text16}
              className={classNames(
                "all",
                "p",
                "p__bvRZj",
                "__wab_text",
                sty.text16,
                {
                  [sty.text16pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.text16pov_officer]: hasVariant($state, "pov", "officer")
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Benefit from automated notifications for critical thresholds, customizable alerts aligned with your institution's needs, and timely reminders for key compliance activities, ensuring proactive adherence to standards."
                : hasVariant($state, "pov", "officer")
                  ? "Optimize resource allocation with FTE CAP Analysis, enhancing productivity and strategic planning. Gain insights into capacity utilization, balancing workloads effectively to maximize savings."
                  : "With integrated milestones & EPAs, track trainee progress comprehensively. Tailored strategies and clear learning objectives ensure consistency in evaluations, aligning with evolving industry standards."}
            </p>
          </div>
          <div
            data-plasmic-name={"textWithIcon14"}
            data-plasmic-override={overrides.textWithIcon14}
            className={classNames("all", sty.textWithIcon14)}
          >
            <div
              data-plasmic-name={"featureIcon14"}
              data-plasmic-override={overrides.featureIcon14}
              className={classNames("all", sty.featureIcon14)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__iDqet, {
                  [sty.imgpov_administrator__iDqet2Yr]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.imgpov_officer__iDqetcOt9]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                })}
                displayHeight={"32px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"32px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant($state, "pov", "administrator")
                    ? {
                        src: "https://site-assets.plasmic.app/c9d5343d55296d4f23164870386db9ad.svg",
                        fullWidth: 155,
                        fullHeight: 150,
                        aspectRatio: 1.03125
                      }
                    : hasVariant($state, "pov", "officer")
                      ? {
                          src: "https://site-assets.plasmic.app/0b262b60f4d3536617e5464967729485.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : {
                          src: "https://site-assets.plasmic.app/fe7498e2fb892eddf0cceef2ce1dc90c.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                }
              />
            </div>
            <h3
              data-plasmic-name={"heading14"}
              data-plasmic-override={overrides.heading14}
              className={classNames(
                "all",
                "h3",
                "h3__bvRZj",
                "__wab_text",
                sty.heading14,
                {
                  [sty.heading14pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.heading14pov_officer]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Identify Gaps in \nTrainee Education"
                : hasVariant($state, "pov", "officer")
                  ? "Support Your Decisions with Historical Data and Trends"
                  : "Easily Onboard Trainees and Manage All Document Requirements"}
            </h3>
            <div
              data-plasmic-name={"freeBox"}
              data-plasmic-override={overrides.freeBox}
              className={classNames("all", sty.freeBox)}
            />

            <p
              data-plasmic-name={"text17"}
              data-plasmic-override={overrides.text17}
              className={classNames(
                "all",
                "p",
                "p__bvRZj",
                "__wab_text",
                sty.text17,
                {
                  [sty.text17pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.text17pov_officer]: hasVariant($state, "pov", "officer")
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Optimize trainee education using MyEvaluations' integrated milestones, EPAs, and MyInsights' AI-generated feedback. Tailor evaluations to meet institution-specific goals, empowering focused growth and readiness for exceptional patient care."
                : hasVariant($state, "pov", "officer")
                  ? "Empower decision-making with MyEvaluations' sophisticated analytics. Utilize insights from Annual Program Evaluations and other reports to identify trends, improve programs, and set new benchmarks in medical education excellence."
                  : "Simplify onboarding and credentialing with automated tools. Ensure compliance, reduce errors, and efficiently validate credentials for resident qualifications. Manage demographic data seamlessly while maintaining secure and organized information access."}
            </p>
          </div>
          <div
            data-plasmic-name={"textWithIcon15"}
            data-plasmic-override={overrides.textWithIcon15}
            className={classNames("all", sty.textWithIcon15)}
          >
            <div
              data-plasmic-name={"featureIcon15"}
              data-plasmic-override={overrides.featureIcon15}
              className={classNames("all", sty.featureIcon15)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__aSi1K, {
                  [sty.imgpov_administrator__aSi1K2Yr]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.imgpov_officer__aSi1KcOt9]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                })}
                displayHeight={"32px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"32px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant($state, "pov", "administrator")
                    ? {
                        src: "https://site-assets.plasmic.app/d3c4632dc560f1e75d09c01b943bb415.svg",
                        fullWidth: 155,
                        fullHeight: 150,
                        aspectRatio: 1.03125
                      }
                    : hasVariant($state, "pov", "officer")
                      ? {
                          src: "https://site-assets.plasmic.app/a2972b2453055fda2ff4271069674fd7.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : {
                          src: "https://site-assets.plasmic.app/3c310446c6021e3ac137c9f7dec8c08f.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                }
              />
            </div>
            <h3
              data-plasmic-name={"heading15"}
              data-plasmic-override={overrides.heading15}
              className={classNames(
                "all",
                "h3",
                "h3__bvRZj",
                "__wab_text",
                sty.heading15,
                {
                  [sty.heading15pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.heading15pov_officer]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Centralize All Your Educational Resources"
                : hasVariant($state, "pov", "officer")
                  ? "Identify Gaps in \nTrainee Education"
                  : "Enhance Academic Performance through Continuous Assessments"}
            </h3>
            <p
              data-plasmic-name={"text18"}
              data-plasmic-override={overrides.text18}
              className={classNames(
                "all",
                "p",
                "p__bvRZj",
                "__wab_text",
                sty.text18,
                {
                  [sty.text18pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.text18pov_officer]: hasVariant($state, "pov", "officer")
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Access high-quality learning materials on demand, foster dynamic curriculum development, and engage trainees with tailored assignments and interactive quizzes, ensuring an enriched learning experience for all."
                : hasVariant($state, "pov", "officer")
                  ? "Optimize trainee education using MyEvaluations' integrated milestones, EPAs, and MyInsights' AI-generated feedback. Tailor evaluations to meet institution-specific goals, empowering focused growth and readiness for exceptional patient care."
                  : "Enrich learning with tailored assignments and interactive quizzes, providing oversight on objectives, and monitoring knowledge retention. Gain insights into trainee performance with assessment tools for continuous improvement."}
            </p>
          </div>
          <div
            data-plasmic-name={"textWithIcon16"}
            data-plasmic-override={overrides.textWithIcon16}
            className={classNames("all", sty.textWithIcon16)}
          >
            <div
              data-plasmic-name={"featureIcon16"}
              data-plasmic-override={overrides.featureIcon16}
              className={classNames("all", sty.featureIcon16)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___4L4V, {
                  [sty.imgpov_administrator___4L4V2Yr]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.imgpov_officer___4L4VcOt9]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                })}
                displayHeight={"32px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"32px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant($state, "pov", "administrator")
                    ? {
                        src: "https://site-assets.plasmic.app/4a7d04d490ec43b544075c6054040e0c.svg",
                        fullWidth: 150,
                        fullHeight: 150,
                        aspectRatio: 1
                      }
                    : hasVariant($state, "pov", "officer")
                      ? {
                          src: "https://site-assets.plasmic.app/eb32ad08bc41319b6a8fca3d9400b78f.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                      : {
                          src: "https://site-assets.plasmic.app/ff4c5cc66db326a029e99abef3aa57d7.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                }
              />
            </div>
            <h3
              data-plasmic-name={"heading16"}
              data-plasmic-override={overrides.heading16}
              className={classNames(
                "all",
                "h3",
                "h3__bvRZj",
                "__wab_text",
                sty.heading16,
                {
                  [sty.heading16pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.heading16pov_officer]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Effortlessly Generate Optimized Schedules"
                : hasVariant($state, "pov", "officer")
                  ? "Develop Exceptional Trainees with Comprehensive Educational Tracking"
                  : "Deliver Quicker and Comprehensive Trainee Narrative Feedback"}
            </h3>
            <p
              data-plasmic-name={"text19"}
              data-plasmic-override={overrides.text19}
              className={classNames(
                "all",
                "p",
                "p__bvRZj",
                "__wab_text",
                sty.text19,
                {
                  [sty.text19pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.text19pov_officer]: hasVariant($state, "pov", "officer")
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "From rotations to clinics, MySchedule streamlines scheduling complexities. Benefit from mobile access, automated scheduling, and unified cross-departmental coordination, all ensuring optimized training workflows."
                : hasVariant($state, "pov", "officer")
                  ? "Drive exceptional trainee development through robust quizzes and tailored learning assignments. With comprehensive educational tracking and real-time progress monitoring, MyEvaluations ensures alignment with goals for enriched learning experiences."
                  : "Experience the power of MyInsights, an AI-driven tool that saves Clinical Competency Committee time. It translates comments and performance data into human-readable, actionable summaries, offering valuable feedback to all trainees."}
            </p>
          </div>
          <div
            data-plasmic-name={"textWithIcon17"}
            data-plasmic-override={overrides.textWithIcon17}
            className={classNames("all", sty.textWithIcon17)}
          >
            <div
              data-plasmic-name={"featureIcon17"}
              data-plasmic-override={overrides.featureIcon17}
              className={classNames("all", sty.featureIcon17)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__vSsMg, {
                  [sty.imgpov_administrator__vSsMg2Yr]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.imgpov_officer__vSsMgcOt9]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                })}
                displayHeight={"32px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"32px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant($state, "pov", "administrator")
                    ? {
                        src: "https://site-assets.plasmic.app/acd1b2c6599f8032a133a63d5f393bcc.svg",
                        fullWidth: 155,
                        fullHeight: 150,
                        aspectRatio: 1.03125
                      }
                    : hasVariant($state, "pov", "officer")
                      ? {
                          src: "https://site-assets.plasmic.app/7b7198bc93fb580da1f9e623ffdb7533.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : {
                          src: "https://site-assets.plasmic.app/1812cd43fefaebf83e3a0ec1eb4d0fa9.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                }
              />
            </div>
            <h3
              data-plasmic-name={"heading17"}
              data-plasmic-override={overrides.heading17}
              className={classNames(
                "all",
                "h3",
                "h3__bvRZj",
                "__wab_text",
                sty.heading17,
                {
                  [sty.heading17pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.heading17pov_officer]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Deliver Quicker and Comprehensive Trainee Narrative Feedback"
                : hasVariant($state, "pov", "officer")
                  ? "Reduce Burnout and Easily Track Clinical Hours"
                  : "Simplify CME Organization and Minimize Admin Burden"}
            </h3>
            <p
              data-plasmic-name={"text20"}
              data-plasmic-override={overrides.text20}
              className={classNames(
                "all",
                "p",
                "p__bvRZj",
                "__wab_text",
                sty.text20,
                {
                  [sty.text20pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.text20pov_officer]: hasVariant($state, "pov", "officer")
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Experience the power of MyInsights, an AI-driven tool that saves Clinical Competency Committee time. It translates comments and performance data into human-readable, actionable summaries, offering valuable feedback to all trainees."
                : hasVariant($state, "pov", "officer")
                  ? "Simplify clinical hour tracking using MyQuickPass' geofence technology, allowing trainees to focus on tasks, promoting their well-being. Automated records ensure compliance, with real-time alerts and streamlined reports benefit administrators."
                  : "Efficiently manage your CME program with streamlined event scheduling, durable event libraries, and precise financial oversight. With MyCME you ensure optimal resource allocation and secure payment processing for fee collection."}
            </p>
          </div>
          <div
            data-plasmic-name={"textWithIcon18"}
            data-plasmic-override={overrides.textWithIcon18}
            className={classNames("all", sty.textWithIcon18)}
          >
            <div
              data-plasmic-name={"featureIcon18"}
              data-plasmic-override={overrides.featureIcon18}
              className={classNames("all", sty.featureIcon18)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__eWPu0, {
                  [sty.imgpov_administrator__eWPu02Yr]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.imgpov_officer__eWPu0COt9]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                })}
                displayHeight={"32px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"32px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  hasVariant($state, "pov", "administrator")
                    ? {
                        src: "https://site-assets.plasmic.app/7d556af7fe90b36896fe9ba459b2f6dc.svg",
                        fullWidth: 155,
                        fullHeight: 150,
                        aspectRatio: 1.03125
                      }
                    : hasVariant($state, "pov", "officer")
                      ? {
                          src: "https://site-assets.plasmic.app/e691a5160e5fa6714b289da2a425b480.svg",
                          fullWidth: 155,
                          fullHeight: 150,
                          aspectRatio: 1.03125
                        }
                      : {
                          src: "https://site-assets.plasmic.app/602539a406e5eb93e4e725bc14216ca0.svg",
                          fullWidth: 32,
                          fullHeight: 32,
                          aspectRatio: 1
                        }
                }
              />
            </div>
            <h3
              data-plasmic-name={"heading18"}
              data-plasmic-override={overrides.heading18}
              className={classNames(
                "all",
                "h3",
                "h3__bvRZj",
                "__wab_text",
                sty.heading18,
                {
                  [sty.heading18pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.heading18pov_officer]: hasVariant(
                    $state,
                    "pov",
                    "officer"
                  )
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Easily Onboard Trainees and Manage All Document Requirements"
                : hasVariant($state, "pov", "officer")
                  ? "Stay Ahead with Proactive Fiscal Management"
                  : "Support Your Decisions with Historical Data and Trends"}
            </h3>
            <p
              data-plasmic-name={"text21"}
              data-plasmic-override={overrides.text21}
              className={classNames(
                "all",
                "p",
                "p__bvRZj",
                "__wab_text",
                sty.text21,
                {
                  [sty.text21pov_administrator]: hasVariant(
                    $state,
                    "pov",
                    "administrator"
                  ),
                  [sty.text21pov_officer]: hasVariant($state, "pov", "officer")
                }
              )}
            >
              {hasVariant($state, "pov", "administrator")
                ? "Simplify onboarding and credentialing with automated tools. Ensure compliance, reduce errors, and efficiently validate credentials for resident qualifications. Manage demographic data seamlessly while maintaining secure and organized information access."
                : hasVariant($state, "pov", "officer")
                  ? "Streamline financial processes, reduce administrative overhead, and ensure transparent dealings with stakeholders. Review submissions proactively for a forward-thinking approach to financial management."
                  : "Empower decision-making with MyEvaluations' sophisticated analytics. Utilize insights from Annual Program Evaluations and other reports to identify trends, improve programs, and set new benchmarks in medical education excellence."}
            </p>
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  items: [
    "items",
    "desktopWrapper",
    "row5",
    "textWithIcon",
    "featureIcon",
    "heading",
    "text11",
    "textWithIcon2",
    "featureIcon2",
    "heading2",
    "text22",
    "textWithIcon3",
    "featureIcon3",
    "heading3",
    "text5",
    "row6",
    "textWithIcon4",
    "featureIcon4",
    "heading4",
    "text6",
    "textWithIcon5",
    "featureIcon5",
    "heading5",
    "text7",
    "textWithIcon6",
    "featureIcon6",
    "heading6",
    "text8",
    "tabletWrapper",
    "row7",
    "textWithIcon7",
    "featureIcon7",
    "heading7",
    "text12",
    "textWithIcon8",
    "featureIcon8",
    "heading8",
    "text9",
    "row8",
    "textWithIcon9",
    "featureIcon9",
    "heading9",
    "text10",
    "textWithIcon10",
    "featureIcon10",
    "heading10",
    "text13",
    "row9",
    "textWithIcon11",
    "featureIcon11",
    "heading11",
    "text14",
    "textWithIcon12",
    "featureIcon12",
    "heading12",
    "text15",
    "mobileWrapper",
    "textWithIcon13",
    "featureIcon13",
    "heading13",
    "text16",
    "textWithIcon14",
    "featureIcon14",
    "heading14",
    "freeBox",
    "text17",
    "textWithIcon15",
    "featureIcon15",
    "heading15",
    "text18",
    "textWithIcon16",
    "featureIcon16",
    "heading16",
    "text19",
    "textWithIcon17",
    "featureIcon17",
    "heading17",
    "text20",
    "textWithIcon18",
    "featureIcon18",
    "heading18",
    "text21"
  ],
  desktopWrapper: [
    "desktopWrapper",
    "row5",
    "textWithIcon",
    "featureIcon",
    "heading",
    "text11",
    "textWithIcon2",
    "featureIcon2",
    "heading2",
    "text22",
    "textWithIcon3",
    "featureIcon3",
    "heading3",
    "text5",
    "row6",
    "textWithIcon4",
    "featureIcon4",
    "heading4",
    "text6",
    "textWithIcon5",
    "featureIcon5",
    "heading5",
    "text7",
    "textWithIcon6",
    "featureIcon6",
    "heading6",
    "text8"
  ],
  row5: [
    "row5",
    "textWithIcon",
    "featureIcon",
    "heading",
    "text11",
    "textWithIcon2",
    "featureIcon2",
    "heading2",
    "text22",
    "textWithIcon3",
    "featureIcon3",
    "heading3",
    "text5"
  ],
  textWithIcon: ["textWithIcon", "featureIcon", "heading", "text11"],
  featureIcon: ["featureIcon"],
  heading: ["heading"],
  text11: ["text11"],
  textWithIcon2: ["textWithIcon2", "featureIcon2", "heading2", "text22"],
  featureIcon2: ["featureIcon2"],
  heading2: ["heading2"],
  text22: ["text22"],
  textWithIcon3: ["textWithIcon3", "featureIcon3", "heading3", "text5"],
  featureIcon3: ["featureIcon3"],
  heading3: ["heading3"],
  text5: ["text5"],
  row6: [
    "row6",
    "textWithIcon4",
    "featureIcon4",
    "heading4",
    "text6",
    "textWithIcon5",
    "featureIcon5",
    "heading5",
    "text7",
    "textWithIcon6",
    "featureIcon6",
    "heading6",
    "text8"
  ],
  textWithIcon4: ["textWithIcon4", "featureIcon4", "heading4", "text6"],
  featureIcon4: ["featureIcon4"],
  heading4: ["heading4"],
  text6: ["text6"],
  textWithIcon5: ["textWithIcon5", "featureIcon5", "heading5", "text7"],
  featureIcon5: ["featureIcon5"],
  heading5: ["heading5"],
  text7: ["text7"],
  textWithIcon6: ["textWithIcon6", "featureIcon6", "heading6", "text8"],
  featureIcon6: ["featureIcon6"],
  heading6: ["heading6"],
  text8: ["text8"],
  tabletWrapper: [
    "tabletWrapper",
    "row7",
    "textWithIcon7",
    "featureIcon7",
    "heading7",
    "text12",
    "textWithIcon8",
    "featureIcon8",
    "heading8",
    "text9",
    "row8",
    "textWithIcon9",
    "featureIcon9",
    "heading9",
    "text10",
    "textWithIcon10",
    "featureIcon10",
    "heading10",
    "text13",
    "row9",
    "textWithIcon11",
    "featureIcon11",
    "heading11",
    "text14",
    "textWithIcon12",
    "featureIcon12",
    "heading12",
    "text15"
  ],
  row7: [
    "row7",
    "textWithIcon7",
    "featureIcon7",
    "heading7",
    "text12",
    "textWithIcon8",
    "featureIcon8",
    "heading8",
    "text9"
  ],
  textWithIcon7: ["textWithIcon7", "featureIcon7", "heading7", "text12"],
  featureIcon7: ["featureIcon7"],
  heading7: ["heading7"],
  text12: ["text12"],
  textWithIcon8: ["textWithIcon8", "featureIcon8", "heading8", "text9"],
  featureIcon8: ["featureIcon8"],
  heading8: ["heading8"],
  text9: ["text9"],
  row8: [
    "row8",
    "textWithIcon9",
    "featureIcon9",
    "heading9",
    "text10",
    "textWithIcon10",
    "featureIcon10",
    "heading10",
    "text13"
  ],
  textWithIcon9: ["textWithIcon9", "featureIcon9", "heading9", "text10"],
  featureIcon9: ["featureIcon9"],
  heading9: ["heading9"],
  text10: ["text10"],
  textWithIcon10: ["textWithIcon10", "featureIcon10", "heading10", "text13"],
  featureIcon10: ["featureIcon10"],
  heading10: ["heading10"],
  text13: ["text13"],
  row9: [
    "row9",
    "textWithIcon11",
    "featureIcon11",
    "heading11",
    "text14",
    "textWithIcon12",
    "featureIcon12",
    "heading12",
    "text15"
  ],
  textWithIcon11: ["textWithIcon11", "featureIcon11", "heading11", "text14"],
  featureIcon11: ["featureIcon11"],
  heading11: ["heading11"],
  text14: ["text14"],
  textWithIcon12: ["textWithIcon12", "featureIcon12", "heading12", "text15"],
  featureIcon12: ["featureIcon12"],
  heading12: ["heading12"],
  text15: ["text15"],
  mobileWrapper: [
    "mobileWrapper",
    "textWithIcon13",
    "featureIcon13",
    "heading13",
    "text16",
    "textWithIcon14",
    "featureIcon14",
    "heading14",
    "freeBox",
    "text17",
    "textWithIcon15",
    "featureIcon15",
    "heading15",
    "text18",
    "textWithIcon16",
    "featureIcon16",
    "heading16",
    "text19",
    "textWithIcon17",
    "featureIcon17",
    "heading17",
    "text20",
    "textWithIcon18",
    "featureIcon18",
    "heading18",
    "text21"
  ],
  textWithIcon13: ["textWithIcon13", "featureIcon13", "heading13", "text16"],
  featureIcon13: ["featureIcon13"],
  heading13: ["heading13"],
  text16: ["text16"],
  textWithIcon14: [
    "textWithIcon14",
    "featureIcon14",
    "heading14",
    "freeBox",
    "text17"
  ],
  featureIcon14: ["featureIcon14"],
  heading14: ["heading14"],
  freeBox: ["freeBox"],
  text17: ["text17"],
  textWithIcon15: ["textWithIcon15", "featureIcon15", "heading15", "text18"],
  featureIcon15: ["featureIcon15"],
  heading15: ["heading15"],
  text18: ["text18"],
  textWithIcon16: ["textWithIcon16", "featureIcon16", "heading16", "text19"],
  featureIcon16: ["featureIcon16"],
  heading16: ["heading16"],
  text19: ["text19"],
  textWithIcon17: ["textWithIcon17", "featureIcon17", "heading17", "text20"],
  featureIcon17: ["featureIcon17"],
  heading17: ["heading17"],
  text20: ["text20"],
  textWithIcon18: ["textWithIcon18", "featureIcon18", "heading18", "text21"],
  featureIcon18: ["featureIcon18"],
  heading18: ["heading18"],
  text21: ["text21"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  items: "div";
  desktopWrapper: "div";
  row5: "div";
  textWithIcon: "div";
  featureIcon: "div";
  heading: "h3";
  text11: "p";
  textWithIcon2: "div";
  featureIcon2: "div";
  heading2: "h3";
  text22: "p";
  textWithIcon3: "div";
  featureIcon3: "div";
  heading3: "h3";
  text5: "p";
  row6: "div";
  textWithIcon4: "div";
  featureIcon4: "div";
  heading4: "h3";
  text6: "p";
  textWithIcon5: "div";
  featureIcon5: "div";
  heading5: "h3";
  text7: "p";
  textWithIcon6: "div";
  featureIcon6: "div";
  heading6: "h3";
  text8: "p";
  tabletWrapper: "div";
  row7: "div";
  textWithIcon7: "div";
  featureIcon7: "div";
  heading7: "h3";
  text12: "p";
  textWithIcon8: "div";
  featureIcon8: "div";
  heading8: "h3";
  text9: "p";
  row8: "div";
  textWithIcon9: "div";
  featureIcon9: "div";
  heading9: "h3";
  text10: "p";
  textWithIcon10: "div";
  featureIcon10: "div";
  heading10: "h3";
  text13: "p";
  row9: "div";
  textWithIcon11: "div";
  featureIcon11: "div";
  heading11: "h3";
  text14: "p";
  textWithIcon12: "div";
  featureIcon12: "div";
  heading12: "h3";
  text15: "p";
  mobileWrapper: "div";
  textWithIcon13: "div";
  featureIcon13: "div";
  heading13: "h3";
  text16: "p";
  textWithIcon14: "div";
  featureIcon14: "div";
  heading14: "h3";
  freeBox: "div";
  text17: "p";
  textWithIcon15: "div";
  featureIcon15: "div";
  heading15: "h3";
  text18: "p";
  textWithIcon16: "div";
  featureIcon16: "div";
  heading16: "h3";
  text19: "p";
  textWithIcon17: "div";
  featureIcon17: "div";
  heading17: "h3";
  text20: "p";
  textWithIcon18: "div";
  featureIcon18: "div";
  heading18: "h3";
  text21: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeBenefitsSectionBenefits__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeBenefitsSectionBenefits__VariantsArgs;
    args?: PlasmicHomeBenefitsSectionBenefits__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeBenefitsSectionBenefits__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeBenefitsSectionBenefits__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeBenefitsSectionBenefits__ArgProps,
          internalVariantPropNames:
            PlasmicHomeBenefitsSectionBenefits__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeBenefitsSectionBenefits__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "items") {
    func.displayName = "PlasmicHomeBenefitsSectionBenefits";
  } else {
    func.displayName = `PlasmicHomeBenefitsSectionBenefits.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeBenefitsSectionBenefits = Object.assign(
  // Top-level PlasmicHomeBenefitsSectionBenefits renders the root element
  makeNodeComponent("items"),
  {
    // Helper components rendering sub-elements
    desktopWrapper: makeNodeComponent("desktopWrapper"),
    row5: makeNodeComponent("row5"),
    textWithIcon: makeNodeComponent("textWithIcon"),
    featureIcon: makeNodeComponent("featureIcon"),
    heading: makeNodeComponent("heading"),
    text11: makeNodeComponent("text11"),
    textWithIcon2: makeNodeComponent("textWithIcon2"),
    featureIcon2: makeNodeComponent("featureIcon2"),
    heading2: makeNodeComponent("heading2"),
    text22: makeNodeComponent("text22"),
    textWithIcon3: makeNodeComponent("textWithIcon3"),
    featureIcon3: makeNodeComponent("featureIcon3"),
    heading3: makeNodeComponent("heading3"),
    text5: makeNodeComponent("text5"),
    row6: makeNodeComponent("row6"),
    textWithIcon4: makeNodeComponent("textWithIcon4"),
    featureIcon4: makeNodeComponent("featureIcon4"),
    heading4: makeNodeComponent("heading4"),
    text6: makeNodeComponent("text6"),
    textWithIcon5: makeNodeComponent("textWithIcon5"),
    featureIcon5: makeNodeComponent("featureIcon5"),
    heading5: makeNodeComponent("heading5"),
    text7: makeNodeComponent("text7"),
    textWithIcon6: makeNodeComponent("textWithIcon6"),
    featureIcon6: makeNodeComponent("featureIcon6"),
    heading6: makeNodeComponent("heading6"),
    text8: makeNodeComponent("text8"),
    tabletWrapper: makeNodeComponent("tabletWrapper"),
    row7: makeNodeComponent("row7"),
    textWithIcon7: makeNodeComponent("textWithIcon7"),
    featureIcon7: makeNodeComponent("featureIcon7"),
    heading7: makeNodeComponent("heading7"),
    text12: makeNodeComponent("text12"),
    textWithIcon8: makeNodeComponent("textWithIcon8"),
    featureIcon8: makeNodeComponent("featureIcon8"),
    heading8: makeNodeComponent("heading8"),
    text9: makeNodeComponent("text9"),
    row8: makeNodeComponent("row8"),
    textWithIcon9: makeNodeComponent("textWithIcon9"),
    featureIcon9: makeNodeComponent("featureIcon9"),
    heading9: makeNodeComponent("heading9"),
    text10: makeNodeComponent("text10"),
    textWithIcon10: makeNodeComponent("textWithIcon10"),
    featureIcon10: makeNodeComponent("featureIcon10"),
    heading10: makeNodeComponent("heading10"),
    text13: makeNodeComponent("text13"),
    row9: makeNodeComponent("row9"),
    textWithIcon11: makeNodeComponent("textWithIcon11"),
    featureIcon11: makeNodeComponent("featureIcon11"),
    heading11: makeNodeComponent("heading11"),
    text14: makeNodeComponent("text14"),
    textWithIcon12: makeNodeComponent("textWithIcon12"),
    featureIcon12: makeNodeComponent("featureIcon12"),
    heading12: makeNodeComponent("heading12"),
    text15: makeNodeComponent("text15"),
    mobileWrapper: makeNodeComponent("mobileWrapper"),
    textWithIcon13: makeNodeComponent("textWithIcon13"),
    featureIcon13: makeNodeComponent("featureIcon13"),
    heading13: makeNodeComponent("heading13"),
    text16: makeNodeComponent("text16"),
    textWithIcon14: makeNodeComponent("textWithIcon14"),
    featureIcon14: makeNodeComponent("featureIcon14"),
    heading14: makeNodeComponent("heading14"),
    freeBox: makeNodeComponent("freeBox"),
    text17: makeNodeComponent("text17"),
    textWithIcon15: makeNodeComponent("textWithIcon15"),
    featureIcon15: makeNodeComponent("featureIcon15"),
    heading15: makeNodeComponent("heading15"),
    text18: makeNodeComponent("text18"),
    textWithIcon16: makeNodeComponent("textWithIcon16"),
    featureIcon16: makeNodeComponent("featureIcon16"),
    heading16: makeNodeComponent("heading16"),
    text19: makeNodeComponent("text19"),
    textWithIcon17: makeNodeComponent("textWithIcon17"),
    featureIcon17: makeNodeComponent("featureIcon17"),
    heading17: makeNodeComponent("heading17"),
    text20: makeNodeComponent("text20"),
    textWithIcon18: makeNodeComponent("textWithIcon18"),
    featureIcon18: makeNodeComponent("featureIcon18"),
    heading18: makeNodeComponent("heading18"),
    text21: makeNodeComponent("text21"),

    // Metadata about props expected for PlasmicHomeBenefitsSectionBenefits
    internalVariantProps: PlasmicHomeBenefitsSectionBenefits__VariantProps,
    internalArgProps: PlasmicHomeBenefitsSectionBenefits__ArgProps
  }
);

export default PlasmicHomeBenefitsSectionBenefits;
/* prettier-ignore-end */
